import Vue from 'vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Router, { Route } from 'vue-router'
import staticRouters from '@/router/router_mgr/routers'
import DynamicRoutes from './router_mgr/dynamic_routes'
import FuncUtils from '@/common/utils/FuncUtils'
import { UserModule } from '@/store/modules/user'
import { AppModule } from '@/store/modules/app'
import JavaHttp from '@/common/network/JavaHttp'
import CookiesUtils from '@/common/utils/CookiesUtils'

Vue.use(Router)
NProgress.configure({ showSpinner: false })
const getNewRouter = () => {
  let ret = staticRouters(false)
  if (FuncUtils.isValidate()) {
    try {
      UserModule.localUserInfo()
      const buff = CookiesUtils.getRoles()
      const dynamic = DynamicRoutes.parseRouteArray(buff, '')
      ret = ret.concat(dynamic)
      console.log('DynamicRoutes add finish', dynamic)
    } catch (error) {
      // console.log(error)
      UserModule.clearUserInfo()
      console.log('get user info exception')
    }
    // // 更新菜单项
    JavaHttp.getData('/menu/getRouters', null).then((accessRoutes: any) => {
      // 根据roles权限生成可访问的路由表
      CookiesUtils.setRoles(accessRoutes.data)
    })
    JavaHttp.getData('/user/getInfo', null).then((ret: any) => {
      let levelId = 1
      if (ret.data.user.levelId) {
        levelId = ret.data.user.levelId
      }
      localStorage.setItem('belongCode', ret.data.user.belongCode)
      console.log('token', UserModule.token)
      const user = {
        id: ret.data.user.id,
        account: ret.data.user.userName,
        phone: ret.data.user.mobilePhone,
        name: ret.data.user.nickName,
        token: UserModule.token,
        loginPlate: '管理后台',
        avatar: ret.data.user.avatar,
        desensitizeFlag: ret.data.user.desensitizeFlag,
        // provinceCode: ret.data.user.provinceCode,
        // cityCode: ret.data.user.cityCode,
        // countyCode: ret.data.user.countyCode,
        // streetCode: ret.data.user.streetCode,
        roleId: ret.data.user.roles[0].roleId,
        levelId: levelId,
        roles: ret.data.roles,
        permissions: ret.data.permissions
      }
      UserModule.saveUserInfo(user)
      CookiesUtils.setPermissions(user)
    })
  }
  return ret
}

const createRouter = () => {
  const ret = getNewRouter()
  console.log('ret', ret)
  return new Router({
    mode: 'hash',
    scrollBehavior: (to: Route, from: Route, savedPosition: any) => {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
    routes: ret
  })
}

const getPageTitle = (key: string) => {
  const title: string = process.env.VUE_APP_NAME + '-' + key
  return title
}

const router = createRouter()
// 白名单列表
const whiteList = ['/login']

router.beforeEach((to: Route, from: Route, next: any) => {
  // console.log(to, from)
  NProgress.start()

  // 页面跳转之前重置时间差
  try {
    JavaHttp.postDataCallback(
      '/public/currentTimeMillis',
      {},
      (ret: boolean, res: any) => {
        if (res.code === 0) {
          const currTime = parseInt((Date.now() / 1000).toString(), 10)
          const serverTime = parseInt((res.data / 1000).toString(), 10)
          localStorage.setItem('server-time-diff', `${serverTime - currTime}`)
        } else {
          localStorage.setItem('server-time-diff', `${0}`)
        }
      }
    )
  } catch (e) {
    console.log(e)
  }

  if (FuncUtils.isValidate()) {
    if (to.path === '/login') {
      console.log('jump to home')
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) >= 0) {
      console.log('jump to login')
      next()
      // next({ path: '/login' })
    } else {
      console.log('jump to login finish')
      next({ path: '/login' })
    }
  }
  NProgress.done()
})

router.afterEach((to: Route) => {
  // Finish progress bar
  NProgress.done()
  // set page title
  if (to && to.meta) {
    document.title = getPageTitle(to.meta.title)
  } else {
    document.title = '标题未定义'
  }
})

export default router
